import React from 'react'
import styled from 'styled-components'
import { Box, Flex, Link, Text, getPaletteColor } from 'pcln-design-system'
import { TripDetailsBoxProps } from './types'
import { trackViewTripClick, getProductIconFilled } from './utils'

const ViewTripLink = styled(Link)`
  font-size: 14px;
  font-weight: bold;
`

function TripDetailsBox({
  product,
  headline,
  subHeadline
}: TripDetailsBoxProps) {
  const ProductIcon = getProductIconFilled(product || 'hotel')

  return (
    <>
      <Flex alignItems="center">
        <Flex
          justifyContent="center"
          alignItems="center"
          borderRadius="full"
          mr={2}
          minWidth="56px"
          minHeight="56px"
          bg={getPaletteColor('priceSecondary.light')}
        >
          <ProductIcon color="primary.dark" size="32px" mr={2} />
        </Flex>
        <Box ml={1}>
          <Text color="text" textStyle="heading4" mb={1}>
            {headline}
          </Text>
          <Text color="text.base" textStyle="subheading6" mt={1}>
            {subHeadline}
          </Text>
        </Box>
      </Flex>
      <ViewTripLink
        href="/next-profile/trips"
        onClick={trackViewTripClick}
        variation="fill"
        mt={3}
        mr="auto"
        width={1}
      >
        View Trip
      </ViewTripLink>
    </>
  )
}

export default TripDetailsBox
